import { render, staticRenderFns } from "./InboxSingle.vue?vue&type=template&id=15174c53"
import script from "./InboxSingle.vue?vue&type=script&lang=js"
export * from "./InboxSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports